'use client';

import classnames from 'classnames';

import type { Icon } from '@personly/libs-types';

import { IconView } from '../index.js';

const makeChildrenClassName = (disabled: boolean) =>
  classnames({
    flex: true,
    'justify-start': true,
    'items-start': true,
    'text-input-icon-disabled-color': disabled,
    'text-input-icon-color': !disabled,
  });

const makeIconClassName = (disabled: boolean) =>
  classnames({
    'cursor-pointer': true,
    'text-input-icon-disabled-color': disabled,
    'text-input-icon-color': !disabled,
  });

interface Props {
  children: string;
  disabled?: boolean;
  icon?: Icon;
  id?: string;
  onClick?: () => void;
}

const ToggleDescription = ({
  children,
  disabled = false,
  icon,
  id = undefined,
  onClick,
}: Props) => {
  const childrenTestId = ['toggle', 'description', 'children', id]
    .filter((i) => !!i)
    .join('-');

  const childrenIconId = ['toggle', 'description', 'icon', id]
    .filter((i) => !!i)
    .join('-');

  return (
    <div className={'flex flex-col'}>
      <div className="flex flex-row justify-between">
        <div
          data-testid={childrenTestId}
          className={makeChildrenClassName(disabled)}
        >
          {children}
        </div>
        <div
          data-testid={childrenIconId}
          onClick={() => {
            if (!disabled) onClick?.();
          }}
          className={makeIconClassName(disabled)}
        >
          <IconView size="lg" icon={icon} />
        </div>
      </div>
    </div>
  );
};

export default ToggleDescription;
